import React, { useState, useEffect } from 'react';
import '../../css/properties.css';
import { getActiveHRVProperties } from '../../api/hrv';
import img1 from "../../assets/images/recommend-slides-1.png";
import img2 from "../../assets/images/recommend-slides-2.png";
import img3 from "../../assets/images/recommend-slides-3.png";

// Fallback images for properties without images
const fallbackImages = [img1, img2, img3];

function Properties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 16;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await getActiveHRVProperties();
        
        if (response.success && response.data && response.data.length > 0) {
          setProperties(response.data);
        } else {
          setProperties([]);
        }
      } catch (err) {
        console.error('Failed to fetch properties:', err);
        setError(err.message);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProperties = properties.slice(startIndex, endIndex);

  const goToNextPage = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const goToPrevPage = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <div className="properties-page">
        <div className="container">
          <div className="properties-loading">
            <p>Loading properties...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="properties-page">
      <div className="container">
        <div className="properties-header">
          {/* <h1>All Properties</h1>
          <p>Discover our complete collection of hotels, resorts, and vacation homes</p>
          {properties.length > 0 && (
            <div className="properties-count">
              Showing {startIndex + 1}-{Math.min(endIndex, properties.length)} of {properties.length} properties
            </div>
          )} */}
        </div>

        {error && (
          <div className="properties-error">
            <p>Failed to load properties: {error}</p>
          </div>
        )}

        {properties.length === 0 ? (
          <div className="properties-no-data">
            <h3>No Properties Available</h3>
            <p>Check back later for our latest property listings.</p>
          </div>
        ) : (
          <>
            <div className="properties-grid">
              {currentProperties.map((property, index) => {
                const propertyImages = property.images && property.images.length > 0 
                  ? property.images 
                  : [fallbackImages[index % fallbackImages.length]];
                
                const handleCardClick = () => {
                  if (property.bookingUrl) {
                    window.open(property.bookingUrl, '_blank');
                  }
                };

                return (
                  <div 
                    key={property._id || property.id || index} 
                    className="properties-card"
                    onClick={handleCardClick}
                    style={{ cursor: property.bookingUrl ? 'pointer' : 'default' }}
                  >
                    <div className="properties-card-image">
                      <img 
                        src={propertyImages[0]} 
                        alt={property.title} 
                        onError={(e) => {
                          e.target.src = fallbackImages[0];
                        }}
                      />
                    </div>
                    <div className="properties-card-content">
                      <h3 className="properties-card-title">{property.title}</h3>
                      <p className="properties-card-location">{property.location}</p>
                      <div className="properties-card-pricing">
                        <div className="properties-card-rates">Rates start from</div>
                        <div className="properties-card-price-section">
                          <span className="properties-card-price">₱ {property.price}</span>
                          <span className="properties-card-per-night">/ night</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {totalPages > 1 && (
              <div className="properties-pagination-container">
                <button 
                  onClick={goToPrevPage}
                  disabled={currentPage === 0}
                  className={`properties-pagination-btn properties-prev-btn ${currentPage === 0 ? 'properties-disabled' : ''}`}
                >
                  Previous
                </button>
                
                <div className="properties-pagination-numbers">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i}
                      onClick={() => goToPage(i)}
                      className={`properties-pagination-btn properties-page-btn ${i === currentPage ? 'properties-active' : ''}`}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
                
                <button 
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages - 1}
                  className={`properties-pagination-btn properties-next-btn ${currentPage === totalPages - 1 ? 'properties-disabled' : ''}`}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Properties;